import {configureStore} from "@reduxjs/toolkit";
import userReducer from "./UserSclice";
import moviesReducer from "./MovieSlice";
import gptReducer from "./gptSlice"
import configReducer from "./configSlice";
import detailsReducer from "./detailsSlice";
const appstore = configureStore({
  reducer: {
    user: userReducer,
    movies: moviesReducer,
    gpt: gptReducer,
    config: configReducer,
    details: detailsReducer,
  },
});

export default appstore;
